module.exports = __webpack_public_path__ + "img/login-landscape.911b980e.svg";